import { render, staticRenderFns } from "./VideoInvoiceDetail.vue?vue&type=template&id=ab3bd51a"
import script from "../../services/teacher/VideoCourse/video-invoice-detail.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/VideoCourse/video-invoice-detail.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/invoice/invoice-detail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports